import Controller from "@ember/controller"

export default class PrintController extends Controller {
  queryParams = ["printToken", "printUserId", "fontSize"]
}
